export default "__VITE_ASSET__BTwkPdNY__"